export class SelectData {

    action!: string;
    tenantName!: string;
    userId!: string;
}